import React from 'react';
import { Button, Col } from 'reactstrap';

import { Intl } from 'components';

export default React.memo( () => (
  <Col md="auto" className="pt-1 pt-lg-0 pl-lg-0 d-flex align-items-end mb-1">
    <Button color="primary" id="tableToggler" className="btn-sm" outline>
      <i className="fa fa-filter mr-2" />
      <Intl id="advancedSearch" />
    </Button>
  </Col>
) );
